import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {User} from '../../shared/types/security/user';
import {SecurityService} from '../../shared/services/security/security.service';
import {share} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {SecurityRestService} from '../../shared/services/security/security-rest.service';
import {PersonRestService} from '../../shared/services/person/person-rest.service';
import {FileRestService} from '../../shared/services/common/file/file-rest.service';
import {FileUtilsService} from '../../shared/services/common/file/file-utils.service';

@Component({
  selector: 'wsd-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private subscription: Subscription;

  public user: Observable<User>;

  hostUrl: string = environment.hostUrl;

  servicesUrl: string = environment.servicesUrl;

  intranetUrl: string = environment.intranetUrl;

  visible: boolean;

  scoutOrgUrl = environment.scoutOrgUrl;

  private logoutUrl: string;

  imageSrc: any;

  imageUrl: string;

  constructor(private router: Router,
              private securityService: SecurityService,
              private securityRestService: SecurityRestService,
              private http: HttpClient,
              private personService: PersonRestService,
              private fileRestService: FileRestService,
              private fileUtilsService: FileUtilsService) {
    this.visible = true;
  }

  ngOnInit() {
    this.subscription = this.router.events
      .subscribe(
        (event: any) => {
          if (event instanceof NavigationEnd) {
            this.visible = (event.url !== '/login' && event.urlAfterRedirects !== '/login');
          }
        }
      );
    this.user = this.securityService.getLoggedUser().pipe(share());

    this.user.subscribe((u: User) => {
      this.personService.getProfileImageUrl(u.consultantId).subscribe(url => {
        if (u.imageId != null) {
          this.fileRestService.getImage(u.imageId.toString()).subscribe(
            ((data: any) => {
              this.imageSrc = this.fileUtilsService.getImage(data.content);
              this.imageUrl = null;
            })
          );
        } else {
          this.imageUrl = url;
        }
      });
    });

    this.securityRestService.getLogoutUrl().subscribe(
      (url: string) => {
        this.logoutUrl = url;
      }
    );
  }

  logout() {
    // hack kvoli dev prostrediu, pri settnuti hostUrl v env. subore nastava problem s loginom
    const redirectUri = this.hostUrl !== '' ? this.hostUrl : 'http://localhost:4201/';
    this.http.get(this.hostUrl + '/logout').subscribe(
      () => {
        window.location.href
          = this.logoutUrl + '?redirect_uri=' + redirectUri;
      },
      () => {
        window.location.href
          = this.logoutUrl + '?redirect_uri=' + redirectUri;
      }
    );
  }

  closeMobileMenu() {
    const elm: HTMLElement = <HTMLElement>window.document.querySelector('.burger-menu');
    if (elm) {
      elm.click();
    }
  }

  localeChanged() {
    this.user = this.securityService.getLoggedUser(true).pipe(share());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
